(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-now-checkout"] && !Shopify.designMode) return;
  try {
    window.Noralusin = window.Noralusin || {};
  if (!window.Noralusin.buyNowCheckout) {
    window.Noralusin.buyNowCheckout = async (items) => {
      const query =
        'mutation BuyNow($lines: [CartLineInput!]) { cartCreate(input: { lines: $lines }) { cart { checkoutUrl totalQuantity } userErrors { message } } }';
      const lines = items.map((item) => ({
        merchandiseId: `gid://shopify/ProductVariant/${item.id}`,
        quantity: Number(item.quantity) || 1,
      }));

      const response = await fetch('/api/2026-07/graphql.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ query, variables: { lines } }),
      });
      const data = await response.json().catch(() => ({}));
      const result = data.data && data.data.cartCreate;
      const message =
        (result && result.userErrors && result.userErrors[0] && result.userErrors[0].message) ||
        (data.errors && data.errors[0] && data.errors[0].message);
      if (!response.ok || message || !result || !result.cart || !result.cart.totalQuantity) {
        throw new Error(message || '');
      }
      return result.cart.checkoutUrl;
    };
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-drawer')) {
    class CartDrawer extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const { signal } = this.abort;

        this.dialog = this.closest('dialog');
        this.status = this.querySelector('[data-cart-status]');
        this.root = window.Shopify?.routes?.root || '/';
        this.busy = false;
        this.pending = new Map();

        document.addEventListener(
          'click',
          (event) => {
            const opener = event.target.closest('[data-cart-open]');
            if (!opener || event.defaultPrevented) return;
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            this.open(opener);
          },
          { signal }
        );

        this.addEventListener('click', (event) => this.onClick(event), { signal });
        this.addEventListener('change', (event) => this.onChange(event), { signal });
        this.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
        this.addEventListener(
          'submit',
          (event) => {
            if (this.busy) {
              event.preventDefault();
              return;
            }
            const form = event.target.closest('[data-ritual-add]');
            if (form) {
              event.preventDefault();
              this.addSuggestion(form);
            }
          },
          { signal }
        );

        this.dialog.addEventListener(
          'click',
          (event) => {
            if (event.target === this.dialog) this.close();
          },
          { signal }
        );

        this.dialog.addEventListener(
          'cancel',
          (event) => {
            event.preventDefault();
            this.close();
          },
          { signal }
        );

        this.dialog.addEventListener('close', () => this.onClose(), { signal });

        document.addEventListener('noralusin:cart-add', (event) => this.onAdded(event.detail), { signal });

        /* A page restored from the back/forward cache may show an old bag. */
        window.addEventListener(
          'pageshow',
          (event) => {
            if (event.persisted) this.refresh();
          },
          { signal }
        );
      }

      disconnectedCallback() {
        this.abort.abort();
        this.pending.forEach((timer) => clearTimeout(timer));
      }

      get contents() {
        return this.querySelector('[data-cart-contents]');
      }

      open(opener) {
        if (this.dialog.open) return;
        this.opener = opener || document.activeElement;
        this.dialog.classList.remove('is-closing');
        this.dialog.showModal();
        document.querySelectorAll('[data-cart-open]').forEach((el) => el.setAttribute('aria-expanded', 'true'));
        this.querySelector('[data-cart-close]')?.focus();
      }

      close() {
        if (!this.dialog.open || this.dialog.classList.contains('is-closing')) return;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced) {
          this.dialog.close();
          return;
        }
        this.dialog.classList.add('is-closing');
        setTimeout(() => this.dialog.close(), 280);
      }

      onClose() {
        this.dialog.classList.remove('is-closing');
        document.querySelectorAll('[data-cart-open]').forEach((el) => el.setAttribute('aria-expanded', 'false'));

        /* The header re-renders its bag link after an add, so fall back to
           the current one if the element that opened the drawer is gone. */
        let target = this.opener;
        if (!target || target === document.body || !target.isConnected || !target.checkVisibility?.()) {
          target = Array.from(document.querySelectorAll('[data-cart-open]')).find((el) => el.checkVisibility?.());
        }
        target?.focus({ preventScroll: true });
      }

      onClick(event) {
        if (event.target.closest('[data-cart-close]')) {
          this.close();
          return;
        }

        const remove = event.target.closest('[data-remove]');
        if (remove) {
          event.preventDefault();
          const line = remove.closest('[data-line]');
          if (line && !this.busy) this.commit(line, 0);
          return;
        }

        const step = event.target.closest('[data-qty-step]');
        if (step) {
          const line = step.closest('[data-line]');
          const input = line?.querySelector('[data-qty-input]');
          if (!input || this.busy) return;
          const max = input.max === '' ? Infinity : Number(input.max);
          const next = Math.min(max, Math.max(0, (parseInt(input.value, 10) || 0) + Number(step.dataset.qtyStep)));
          input.value = next;
          /* Rapid clicks are gathered into one request. */
          clearTimeout(this.pending.get(line.dataset.key));
          this.pending.set(
            line.dataset.key,
            setTimeout(() => this.commit(line, next), 350)
          );
        }
      }

      onChange(event) {
        const input = event.target.closest('[data-qty-input]');
        if (!input) return;
        const line = input.closest('[data-line]');
        this.commitInput(line, input);
      }

      onKeydown(event) {
        const input = event.target.closest('[data-qty-input]');
        if (!input || event.key !== 'Enter') return;
        event.preventDefault();
        this.commitInput(input.closest('[data-line]'), input);
      }

      commitInput(line, input) {
        if (!line || this.busy) return;
        const step = Number(input.step) || 1;
        const max = input.max === '' ? Infinity : Number(input.max);
        let value = parseInt(input.value, 10);
        if (Number.isNaN(value)) value = Number(line.dataset.quantity);
        value = Math.min(max, Math.max(0, Math.round(value / step) * step));
        input.value = value;
        if (value !== Number(line.dataset.quantity)) this.commit(line, value);
      }

      async commit(line, quantity) {
        const key = line.dataset.key;
        clearTimeout(this.pending.get(key));
        this.pending.delete(key);
        if (this.busy) return;
        if (quantity === Number(line.dataset.quantity)) return;

        const title = line.dataset.title;
        const focusId = this.contains(document.activeElement) ? document.activeElement.dataset.focusId : null;
        this.setBusy(true, line);

        try {
          const response = await fetch(`${this.root}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity, sections: 'cart-drawer', sections_url: window.location.pathname }),
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || '');
          if (!this.render(data.sections?.['cart-drawer'])) await this.refresh();

          const template = quantity === 0 ? this.dataset.textRemoved : this.dataset.textUpdated;
          this.announce(template.replace('[title]', title).replace('[quantity]', quantity));
          this.restoreFocus(focusId);
        } catch (error) {
          /* Show the real cart again, then say what went wrong beside the line. */
          await this.refresh();
          this.showError(key, error.message || this.dataset.textError);
          this.restoreFocus(focusId);
        } finally {
          this.setBusy(false);
        }
      }

      /* "Complete the ritual": add one product, then show it as a new line. */
      async addSuggestion(form) {
        const title = form.dataset.title;
        const id = Number(new FormData(form).get('id'));
        this.setBusy(true, form.closest('.cart-ritual__item'));

        try {
          const response = await fetch(`${this.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id, quantity: 1 }],
              sections: 'cart-drawer',
              sections_url: window.location.pathname,
            }),
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || '');
          if (!this.render(data.sections?.['cart-drawer'])) await this.refresh();

          const key = data.items?.[0]?.key;
          const line = Array.from(this.querySelectorAll('[data-line]')).find((el) => el.dataset.key === key);
          line?.classList.add('is-new');
          this.announce(this.dataset.textRitualAdded.replace('[title]', title));
          this.restoreFocus(key ? `title-${key}` : null);
        } catch (error) {
          await this.refresh();
          this.showError(null, error.message || this.dataset.textError);
          this.restoreFocus(null);
        } finally {
          this.setBusy(false);
        }
      }

      setBusy(busy, line) {
        this.busy = busy;
        this.classList.toggle('is-updating', busy);
        this.contents?.setAttribute('aria-busy', String(busy));
        line?.classList.toggle('is-updating', busy);
      }

      /* Swaps in freshly rendered contents; returns false if there were none. */
      render(html) {
        if (!html) return false;
        const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-contents]');
        if (!next) return false;
        this.contents.replaceWith(next);
        this.syncCount(next.dataset.count, next.dataset.label);
        return true;
      }

      async refresh() {
        try {
          const response = await fetch(`${this.root}?sections=cart-drawer`, { headers: { Accept: 'application/json' } });
          if (!response.ok) return false;
          const sections = await response.json();
          return this.render(sections['cart-drawer']);
        } catch (error) {
          return false;
        }
      }

      /* Keeps every bag count in the header in step with the cart. */
      syncCount(count, label) {
        const total = Number(count) || 0;
        document.querySelectorAll('.site-header__cart').forEach((link) => {
          const hidden = link.querySelector('.visually-hidden');
          if (hidden && label) hidden.textContent = label;
          let badge = link.querySelector('.site-header__cart-count');
          if (total > 0) {
            if (!badge) {
              badge = document.createElement('span');
              badge.className = 'site-header__cart-count';
              badge.setAttribute('aria-hidden', 'true');
              link.append(badge);
            }
            badge.textContent = total;
          } else {
            badge?.remove();
          }
        });
      }

      restoreFocus(focusId) {
        if (!this.dialog.open) return;
        const target =
          (focusId && this.querySelector(`[data-focus-id="${CSS.escape(focusId)}"]`)) ||
          this.querySelector('#cart-drawer-heading');
        target?.focus({ preventScroll: false });
      }

      showError(key, message) {
        const error = document.createElement('p');
        error.className = 'cart-drawer__error';
        error.setAttribute('role', 'alert');
        error.textContent = message;
        const line = Array.from(this.querySelectorAll('[data-line]')).find((el) => el.dataset.key === key);
        const place = line?.querySelector('.cart-drawer__details') || this.querySelector('.cart-drawer__foot');
        if (place) place.append(error);
        else this.announce(message);
      }

      announce(message) {
        this.status.textContent = '';
        requestAnimationFrame(() => {
          this.status.textContent = message;
        });
      }

      /* After an add anywhere in the store: show the real bag, then open it
         with the new line in view. */
      async onAdded(detail) {
        const opener = document.activeElement;
        await this.refresh();

        const keys = (detail?.items || [detail]).map((item) => item?.key).filter(Boolean);
        const lines = Array.from(this.querySelectorAll('[data-line]')).filter((el) => keys.includes(el.dataset.key));

        this.open(opener);
        lines.forEach((line) => line.classList.add('is-new'));
        lines[0]?.scrollIntoView({ block: 'nearest' });
        this.announce(this.dataset.textAdded);
      }
    }

    customElements.define('cart-drawer', CartDrawer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hero-showcase"] && !Shopify.designMode) return;
  try {
    class HeroShowcase extends HTMLElement {
    connectedCallback() {
      this.bottles = [...this.querySelectorAll('.showcase__bottle')];
      this.labels = [...this.querySelectorAll('.showcase__label')];
      this.interval = Number(this.dataset.interval) || 4500;
      this.index = 0;
      this.inView = true;

      // Run the set number of full cycles (data-cycles), then rest on Root
      // Elixir. Steps only count while the stage is on screen.
      this.home = Number(this.dataset.home) || 0;
      this.stepsLeft = this.bottles.length * Number(this.dataset.cycles || 2) - 1;
      this.settled = false;

      // Phones show a still composition, so the sequence does not run there.
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.phone = window.matchMedia('(max-width: 47.99rem)');
      this.onMotionChange = () => this.sync();
      this.motion.addEventListener('change', this.onMotionChange);
      this.phone.addEventListener('change', this.onMotionChange);

      this.stage = this.querySelector('.showcase__stage');

      // Observe the stage: this element is display: contents and has no box.
      this.observer = new IntersectionObserver((entries) => {
        this.inView = entries[0].isIntersecting;
      });
      this.observer.observe(this.stage);

      this.onOver = (event) => {
        if (event.pointerType !== 'mouse' || !this.hasAttribute('data-running')) return;
        const bottle = event.target.closest('.showcase__bottle');
        if (!bottle) return;
        this.hovering = true;
        this.stop();
        this.focus(Number(bottle.dataset.index));
      };
      this.onLeave = (event) => {
        if (event.pointerType !== 'mouse' || !this.hovering) return;
        this.hovering = false;
        if (this.settled) {
          this.focus(this.home);
        } else {
          this.start();
        }
      };
      this.stage.addEventListener('pointerover', this.onOver);
      this.stage.addEventListener('pointerleave', this.onLeave);

      this.sync();
    }

    disconnectedCallback() {
      this.stop();
      this.observer?.disconnect();
      this.motion?.removeEventListener('change', this.onMotionChange);
      this.phone?.removeEventListener('change', this.onMotionChange);
      this.stage?.removeEventListener('pointerover', this.onOver);
      this.stage?.removeEventListener('pointerleave', this.onLeave);
    }

    sync() {
      if (this.motion.matches || this.phone.matches) {
        this.stop();
        this.removeAttribute('data-running');
        return;
      }
      this.setAttribute('data-running', '');
      this.focus(this.index);
      if (!this.settled) this.start();
    }

    focus(index) {
      this.index = index;
      this.bottles.forEach((el, i) => el.classList.toggle('is-focus', i === index));
      this.labels.forEach((el, i) => el.classList.toggle('is-focus', i === index));
    }

    start() {
      this.stop();
      this.timer = window.setInterval(() => {
        if (!this.inView) return;
        if (this.stepsLeft > 0) {
          this.stepsLeft -= 1;
          this.focus((this.index + 1) % this.bottles.length);
        } else {
          this.settle();
        }
      }, this.interval);
    }

    settle() {
      this.stop();
      this.settled = true;
      this.setAttribute('data-settled', '');
      this.focus(this.home);
    }

    stop() {
      window.clearInterval(this.timer);
    }
  }

  if (!customElements.get('hero-showcase')) customElements.define('hero-showcase', HeroShowcase);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-gallery"] && !Shopify.designMode) return;
  try {
    class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      if (!this.track || this.slides.length < 2) return;

      this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
      this.marks = Array.from(this.querySelectorAll('[data-gallery-mark]'));
      this.prev = this.querySelector('[data-gallery-prev]');
      this.next = this.querySelector('[data-gallery-next]');
      this.index = -1;
      this.frame = 0;

      this.onScroll = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      };
      this.onVariant = (event) => {
        const mediaId = event.detail && event.detail.mediaId;
        if (!mediaId) return;
        const target = this.slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
        if (target > -1) this.show(target);
      };

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => this.show(i)));
      this.marks.forEach((mark, i) => mark.addEventListener('click', () => this.show(i)));
      if (this.prev) this.prev.addEventListener('click', () => this.show(this.index - 1));
      if (this.next) this.next.addEventListener('click', () => this.show(this.index + 1));
      document.addEventListener('pdp:variant-change', this.onVariant);

      this.setAttribute('data-ready', '');
      const start = parseInt(this.dataset.start, 10) || 0;
      this.show(start, false);
    }

    disconnectedCallback() {
      document.removeEventListener('pdp:variant-change', this.onVariant);
      if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
    }

    show(index, smooth = true) {
      const target = Math.max(0, Math.min(this.slides.length - 1, index));
      this.track.scrollTo({ left: this.slides[target].offsetLeft, behavior: smooth ? 'smooth' : 'instant' });
      this.setActive(target);
    }

    sync() {
      const width = this.track.clientWidth || 1;
      this.setActive(Math.round(this.track.scrollLeft / width));
    }

    setActive(index) {
      if (index === this.index || !this.slides[index]) return;
      this.index = index;

      this.thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === index)));
      this.marks.forEach((mark, i) => mark.setAttribute('aria-current', String(i === index)));
      if (this.prev) this.prev.disabled = index === 0;
      if (this.next) this.next.disabled = index === this.slides.length - 1;

      /* Keep the active thumbnail in view inside the rail without moving the page. */
      const thumb = this.thumbs[index];
      const rail = thumb && thumb.parentElement;
      if (rail && rail.scrollHeight > rail.clientHeight) {
        const top = thumb.offsetTop - rail.offsetTop;
        if (top < rail.scrollTop) rail.scrollTop = top;
        else if (top + thumb.offsetHeight > rail.scrollTop + rail.clientHeight) {
          rail.scrollTop = top + thumb.offsetHeight - rail.clientHeight;
        }
      }
    }
  }

  if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /* Adds a card's product to the cart without leaving the page, then asks the
     server for a fresh header so the cart count and its label stay correct.
     Without JavaScript the form posts to the cart normally. */
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-quick-add]')) return;

    event.preventDefault();

    if (event.submitter && event.submitter.hasAttribute('data-buy-now')) {
      buyNow(form, event.submitter);
      return;
    }

    const button = form.querySelector('button[type="submit"]');
    const label = form.querySelector('[data-quick-add-label]');
    const status = form.querySelector('[data-quick-add-status]');
    if (!button || !label || button.getAttribute('aria-disabled') === 'true') return;

    const restore = () => {
      label.textContent = button.dataset.labelDefault;
      button.removeAttribute('aria-disabled');
      button.removeAttribute('aria-busy');
    };

    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('aria-busy', 'true');
    label.textContent = button.dataset.labelAdding;
    if (status) status.textContent = '';

    try {
      const response = await fetch(`${form.getAttribute('action')}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || button.dataset.statusError);

      label.textContent = button.dataset.labelAdded;
      button.removeAttribute('aria-busy');
      if (status) status.textContent = button.dataset.statusAdded;

      document.dispatchEvent(new CustomEvent('noralusin:cart-add', { detail: data }));
      await refreshHeaderCart();
      setTimeout(restore, 2400);
    } catch (error) {
      restore();
      if (status) status.textContent = error.message || button.dataset.statusError;
    }
  });

  /* Buy now sends only this card's variant to checkout through a separate
     one-off cart (snippet buy-now-checkout), so the bag is never read or
     changed. Add to bag is held while it works, so nothing is added twice. */
  async function buyNow(form, button) {
    const add = form.querySelector('[data-quick-add-label]')?.closest('button');
    const label = button.querySelector('[data-buy-now-label]');
    const status = form.querySelector('[data-quick-add-status]');
    if (button.getAttribute('aria-busy') === 'true') return;
    if (add && add.getAttribute('aria-busy') === 'true') return;
    if (!window.Noralusin || !window.Noralusin.buyNowCheckout) {
      // The checkout helper did not load: fall back to the plain form route.
      form.insertAdjacentHTML('beforeend', '<input type="hidden" name="return_to" value="/checkout">');
      form.submit();
      return;
    }

    const labelDefault = label.textContent;
    const addWasDisabled = add && add.hasAttribute('aria-disabled');
    const restore = () => {
      label.textContent = labelDefault;
      button.removeAttribute('aria-disabled');
      button.removeAttribute('aria-busy');
      if (add && !addWasDisabled) add.removeAttribute('aria-disabled');
    };

    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('aria-busy', 'true');
    if (add) add.setAttribute('aria-disabled', 'true');
    label.textContent = button.dataset.labelProcessing;
    if (status) status.textContent = '';

    try {
      const formData = new FormData(form);
      const checkoutUrl = await window.Noralusin.buyNowCheckout([
        { id: formData.get('id'), quantity: formData.get('quantity') },
      ]);
      // Coming back from checkout with the Back button shows the card ready again.
      window.addEventListener('pageshow', restore, { once: true });
      window.location.assign(checkoutUrl);
    } catch (error) {
      restore();
      if (status) status.textContent = error.message || add?.dataset.statusError || '';
    }
  }

  async function refreshHeaderCart() {
    const current = document.querySelector('.site-header__cart');
    const wrapper = current && current.closest('.shopify-section');
    if (!wrapper) return;

    try {
      const sectionId = wrapper.id.replace(/^shopify-section-/, '');
      const response = await fetch(`${window.location.pathname}?section_id=${encodeURIComponent(sectionId)}`);
      if (!response.ok) return;
      const html = await response.text();
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector('.site-header__cart');
      if (next) current.replaceWith(next);
    } catch (error) {
      /* The item is already in the cart; the count refreshes on the next page load. */
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.root = this.closest('[data-product-root]') || document;
      this.button = this.form.querySelector('[data-add]');
      this.label = this.form.querySelector('[data-add-label]');
      this.buyNow = this.form.querySelector('[data-buy-now]');
      this.buyLabel = this.form.querySelector('[data-buy-label]');
      this.qty = this.form.querySelector('[data-qty]');
      this.qtyInput = this.form.querySelector('[data-qty-input]');
      this.minus = this.form.querySelector('[data-qty-minus]');
      this.plus = this.form.querySelector('[data-qty-plus]');
      this.status = this.form.querySelector('[data-status]');
      this.error = this.form.querySelector('[data-error]');
      this.viewBag = this.form.querySelector('[data-view-bag]');
      this.priceBox = this.root.querySelector('[data-price]');

      const script = this.querySelector('script[data-variants]');
      this.variants = script ? JSON.parse(script.textContent) : [];
      this.fieldsets = Array.from(this.form.querySelectorAll('[data-option-index]'));

      if (this.variants.length) {
        this.idInput = document.createElement('input');
        this.idInput.type = 'hidden';
        this.idInput.name = 'id';
        this.form.prepend(this.idInput);
        this.form.querySelectorAll('noscript, .pdp-buy__fallback').forEach((node) => node.remove());
        this.form.addEventListener('change', (event) => {
          if (event.target.matches('.pdp-option__input')) this.onOptionChange();
        });
        this.onOptionChange(false);
      } else {
        this.idInput = this.form.querySelector('[data-variant-id]');
        const max = this.qtyInput.max ? parseInt(this.qtyInput.max, 10) : null;
        this.limits = { min: parseInt(this.qtyInput.min, 10) || 1, step: parseInt(this.qtyInput.step, 10) || 1, max };
      }

      [this.minus, this.plus].forEach((button) => button && button.removeAttribute('hidden'));
      this.minus.addEventListener('click', () => this.stepQuantity(-1));
      this.plus.addEventListener('click', () => this.stepQuantity(1));
      this.qtyInput.addEventListener('change', () => this.clampQuantity());
      this.form.addEventListener('submit', (event) => this.onSubmit(event));
      if (this.buyNow) {
        this.buyNow.addEventListener('click', (event) => this.onBuyNow(event));
        // Coming back from checkout can restore this page with the button still busy.
        window.addEventListener('pageshow', (event) => {
          if (event.persisted) this.endBuyNow();
        });
      }
      this.refreshQuantityButtons();
    }

    selectedOptions() {
      const options = this.variants[0].options.slice();
      this.fieldsets.forEach((fieldset) => {
        const checked = fieldset.querySelector('input:checked');
        if (checked) options[parseInt(fieldset.dataset.optionIndex, 10)] = checked.value;
      });
      return options;
    }

    matchVariant(options) {
      return this.variants.find((variant) => variant.options.every((value, i) => value === options[i]));
    }

    onOptionChange(announce = true) {
      const options = this.selectedOptions();
      const variant = this.matchVariant(options);

      this.fieldsets.forEach((fieldset) => {
        const index = parseInt(fieldset.dataset.optionIndex, 10);
        const checked = fieldset.querySelector('input:checked');
        const selected = fieldset.querySelector('[data-option-selected]');
        if (checked && selected) selected.textContent = checked.value;

        fieldset.querySelectorAll('.pdp-option__input').forEach((input) => {
          const label = input.nextElementSibling;
          const state = label.querySelector('[data-option-state]');
          const candidate = options.slice();
          candidate[index] = input.value;
          const match = this.matchVariant(candidate);
          if (match && match.available) {
            label.removeAttribute('data-state');
            state.textContent = '';
          } else {
            label.setAttribute('data-state', match ? 'sold-out' : 'unavailable');
            state.textContent = ` (${this.button.dataset[match ? 'labelSoldOut' : 'labelUnavailable']})`;
          }
        });
      });

      this.applyVariant(variant, announce);
    }

    applyVariant(variant, announce) {
      this.variant = variant || null;
      if (this.error) this.error.textContent = '';

      if (variant) {
        this.idInput.value = variant.id;
        this.limits = { min: variant.min, step: variant.step, max: variant.max };
        if (this.priceBox) this.priceBox.innerHTML = variant.price_html;

        if (announce) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      } else {
        this.idInput.value = '';
        this.limits = { min: 1, step: 1, max: null };
      }

      const available = Boolean(variant && variant.available);
      this.button.disabled = !available;
      this.qty.hidden = !available;
      if (this.buyNow) {
        this.buyNow.disabled = !available;
        this.buyNow.hidden = !available;
      }
      this.setLabel(
        available
          ? this.button.dataset.labelAdd
          : variant
            ? this.button.dataset.labelSoldOut
            : this.button.dataset.labelUnavailable
      );

      this.qtyInput.min = this.limits.min;
      this.qtyInput.step = this.limits.step;
      if (this.limits.max === null) this.qtyInput.removeAttribute('max');
      else this.qtyInput.max = this.limits.max;
      this.qtyInput.value = this.limits.min;
      this.refreshQuantityButtons();

      if (announce && variant) {
        document.dispatchEvent(
          new CustomEvent('pdp:variant-change', { detail: { variant, mediaId: variant.media_id } })
        );
      }
    }

    setLabel(text) {
      this.label.textContent = text;
    }

    clampQuantity() {
      const { min, step, max } = this.limits;
      let value = parseInt(this.qtyInput.value, 10);
      if (Number.isNaN(value)) value = min;
      value = Math.max(min, value);
      if (step > 1) value = min + Math.round((value - min) / step) * step;
      if (max !== null) value = Math.min(value, max);
      this.qtyInput.value = value;
      this.refreshQuantityButtons();
    }

    stepQuantity(direction) {
      const { min, step, max } = this.limits;
      let value = (parseInt(this.qtyInput.value, 10) || min) + direction * step;
      value = Math.max(min, value);
      if (max !== null) value = Math.min(value, max);
      this.qtyInput.value = value;
      this.refreshQuantityButtons();
    }

    refreshQuantityButtons() {
      const { min, max } = this.limits;
      const value = parseInt(this.qtyInput.value, 10) || min;
      this.minus.disabled = value <= min;
      this.plus.disabled = max !== null && value >= max;
    }

    async onSubmit(event) {
      event.preventDefault();
      if (this.button.disabled || this.button.getAttribute('aria-busy') === 'true') return;

      this.clampQuantity();
      this.status.textContent = '';
      this.error.textContent = '';
      this.viewBag.hidden = true;
      this.button.setAttribute('aria-busy', 'true');
      this.setLabel(this.button.dataset.labelAdding);

      try {
        const response = await fetch(`${this.form.getAttribute('action')}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(this.form),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || this.button.dataset.statusError);

        this.button.removeAttribute('aria-busy');
        this.setLabel(this.button.dataset.labelAdded);
        this.status.textContent = this.button.dataset.statusAdded;
        this.viewBag.hidden = false;

        document.dispatchEvent(new CustomEvent('noralusin:cart-add', { detail: data }));
        await this.refreshHeaderCart();
        window.setTimeout(() => {
          if (this.button.getAttribute('aria-busy') !== 'true') this.setLabel(this.button.dataset.labelAdd);
        }, 2400);
      } catch (error) {
        this.button.removeAttribute('aria-busy');
        this.setLabel(this.button.dataset.labelAdd);
        this.error.textContent = error.message || this.button.dataset.statusError;
      }
    }

    async onBuyNow(event) {
      // Take over from the native submit (which also works, without JavaScript, via return_to).
      event.preventDefault();
      if (this.buyNow.disabled || this.buyNow.getAttribute('aria-busy') === 'true') return;
      if (this.button.getAttribute('aria-busy') === 'true') return;

      this.clampQuantity();
      this.status.textContent = '';
      this.error.textContent = '';
      this.viewBag.hidden = true;
      // Holds Add to bag while the checkout is being prepared, so nothing is added twice.
      this.button.setAttribute('aria-busy', 'true');
      this.buyNow.setAttribute('aria-busy', 'true');
      this.buyLabelDefault = this.buyLabel.textContent;
      this.buyLabel.textContent = this.buyNow.dataset.labelProcessing;

      try {
        // A separate one-off cart with only this variant and quantity, so the bag is left untouched.
        const formData = new FormData(this.form);
        const checkoutUrl = await window.Noralusin.buyNowCheckout([
          { id: formData.get('id'), quantity: formData.get('quantity') },
        ]);
        window.location.assign(checkoutUrl);
      } catch (error) {
        this.endBuyNow();
        this.error.textContent = error.message || this.button.dataset.statusError;
      }
    }

    endBuyNow() {
      this.button.removeAttribute('aria-busy');
      this.buyNow.removeAttribute('aria-busy');
      if (this.buyLabelDefault) this.buyLabel.textContent = this.buyLabelDefault;
    }

    async refreshHeaderCart() {
      const current = document.querySelector('.site-header__cart');
      const wrapper = current && current.closest('.shopify-section');
      if (!wrapper) return;

      try {
        const sectionId = wrapper.id.replace(/^shopify-section-/, '');
        const response = await fetch(`${window.location.pathname}?section_id=${encodeURIComponent(sectionId)}`);
        if (!response.ok) return;
        const html = await response.text();
        const next = new DOMParser().parseFromString(html, 'text/html').querySelector('.site-header__cart');
        if (next) current.replaceWith(next);
      } catch (error) {
        /* The item is already in the bag; the count refreshes on the next page load. */
      }
    }
  }

  if (!customElements.get('product-form')) customElements.define('product-form', ProductForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ritual-finder-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ritual-finder')) {
    const STORAGE_KEY = 'noralusin:ritual-finder';
    const QUESTION_NAMES = ['area', 'hair', 'wash', 'skin', 'skin_type', 'hands_feet'];

    // The finder that "Find my ritual" opens, looked up at the moment it is
    // needed: the first one on the page that is set up.
    const currentFinder = () => [...document.querySelectorAll('ritual-finder')].find((finder) => finder.ready) || null;

    // One listener for the whole page, added once with the element. Because
    // it finds the finder at click time, a section re-rendered by the Theme
    // Editor (where the new copy can arrive before the old one leaves) never
    // leaves the button without a finder. With no finder yet, the button
    // stays a plain link to its fallback page.
    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-ritual-finder-open]');
      if (!opener) return;
      const finder = currentFinder();
      if (!finder) return;
      event.preventDefault();
      finder.open(opener);
    });

    customElements.define(
      'ritual-finder',
      class RitualFinder extends HTMLElement {
        connectedCallback() {
          this.abort = new AbortController();
          const signal = this.abort.signal;

          this.dialog = this.querySelector('dialog');
          this.form = this.querySelector('[data-form]');
          this.result = this.querySelector('[data-screen="result"]');
          this.actions = this.querySelector('[data-actions]');
          this.rules = JSON.parse(this.querySelector('[data-rules]').textContent);
          this.data = JSON.parse(this.querySelector('[data-finder-data]').textContent);
          this.strings = this.data.strings;
          // British-style lists (no serial comma) for English, as the rest of the site's copy.
          const lang = document.documentElement.lang || 'en';
          this.list = new Intl.ListFormat(lang.startsWith('en') ? 'en-GB' : lang, { style: 'long', type: 'conjunction' });

          this.state = { screen: 'area', excluded: [], optionalIn: [], signature: '' };
          this.recommendation = null;
          this.restore();

          this.form.addEventListener('pointerdown', () => (this.pointerAt = Date.now()), { signal });
          this.form.addEventListener('change', (event) => this.onChange(event), { signal });
          this.form.addEventListener(
            'submit',
            (event) => {
              event.preventDefault();
              this.next();
            },
            { signal }
          );

          this.dialog.addEventListener('click', (event) => this.onClick(event), { signal });
          this.dialog.addEventListener(
            'cancel',
            (event) => {
              event.preventDefault();
              this.close();
            },
            { signal }
          );

          // Focus goes back to the button that opened the finder.
          this.dialog.addEventListener(
            'close',
            () => {
              if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
            },
            { signal }
          );

          // Coming back from checkout or a product page restores this page
          // from the cache: put any busy button back to its label.
          window.addEventListener(
            'pageshow',
            (event) => {
              if (!event.persisted) return;
              this.dialog.querySelectorAll('[aria-busy="true"]').forEach((button) => this.release(button));
            },
            { signal }
          );

          this.ready = true;
          if (window.location.hash === '#find-your-ritual' && currentFinder() === this) this.open();
        }

        disconnectedCallback() {
          this.ready = false;
          this.abort?.abort();
        }

        /* Opening and closing ------------------------------------------------ */
        open(opener) {
          if (this.dialog.open) return;
          this.opener = opener || null;
          this.dialog.classList.remove('is-closing');
          this.dialog.showModal();
          if (this.state.screen === 'result') this.compose({ track: false });
          this.show(this.state.screen);
          this.track('ritual_finder_started', { resumed: this.hasAnswers(), screen: this.state.screen });
        }

        close() {
          if (!this.dialog.open || this.dialog.classList.contains('is-closing')) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.dialog.close();
            return;
          }
          this.dialog.classList.add('is-closing');
          window.setTimeout(() => {
            this.dialog.close();
            this.dialog.classList.remove('is-closing');
          }, 240);
        }

        /* Answers ------------------------------------------------------------ */
        values(name) {
          return [...this.form.querySelectorAll(`[name="${name}"]:checked`)].map((input) => input.value);
        }

        get area() {
          return this.values('area')[0] || null;
        }

        hasAnswers() {
          return QUESTION_NAMES.some((name) => this.values(name).length > 0);
        }

        // The screens for the chosen area, in order. Before an area is chosen
        // the progress reads as three questions, the length of most paths.
        flow() {
          const area = this.area;
          const questions = area ? this.rules[area].questions : ['', ''];
          return ['area', ...questions, 'result'];
        }

        onChange(event) {
          const input = event.target;
          if (!input.name) return;

          if (input.name === 'area') {
            this.track('ritual_category_selected', { area: input.value });
          } else if (input.type === 'checkbox') {
            this.track('ritual_concern_selected', {
              area: this.area,
              question: input.name,
              concern: input.value,
              selected: input.checked,
            });
          } else {
            this.track('ritual_concern_selected', { area: this.area, question: input.name, concern: input.value, selected: true });
          }

          this.updateContinue();
          this.save();

          // A single-choice question moves on by itself after a tap or click,
          // once the choice has been seen. Arrow keys only move the choice.
          if (input.type === 'radio' && this.pointerAt && Date.now() - this.pointerAt < 1200) {
            this.pointerAt = 0;
            window.clearTimeout(this.advanceTimer);
            this.advanceTimer = window.setTimeout(() => this.next(), 320);
          }
        }

        next() {
          const flow = this.flow();
          const index = flow.indexOf(this.state.screen);
          if (index < 0 || !this.canContinue(this.state.screen)) return;
          const target = flow[index + 1];
          if (!target) return;
          if (target === 'result') this.compose();
          this.show(target);
        }

        back() {
          const flow = this.flow();
          const index = flow.indexOf(this.state.screen);
          if (index > 0) this.show(flow[index - 1]);
        }

        canContinue(screen) {
          if (screen === 'result') return false;
          return this.values(screen).length > 0;
        }

        /* Showing a screen --------------------------------------------------- */
        show(screen) {
          const flow = this.flow();
          if (!flow.includes(screen)) screen = 'area';
          window.clearTimeout(this.advanceTimer);
          this.state.screen = screen;

          this.dialog.querySelectorAll('[data-screen]').forEach((element) => {
            element.hidden = element.dataset.screen !== screen;
          });
          this.dialog.dataset.screen = screen;

          const isResult = screen === 'result';
          this.actions.hidden = isResult;
          this.form.hidden = isResult;

          const questions = flow.length - 1;
          const index = flow.indexOf(screen);
          const current = Math.min(index + 1, questions);
          const pad = (number) => String(number).padStart(2, '0');
          this.querySelector('[data-progress-current]').textContent = pad(current);
          this.querySelector('[data-progress-total]').textContent = pad(questions);
          this.querySelector('[data-progress-text]').textContent = this.strings.progress
            .replace('[current]', current)
            .replace('[total]', questions);
          this.dialog.style.setProperty('--rfinder-progress', isResult ? '100%' : `${((index + 1) / (questions + 1)) * 100}%`);

          const back = this.dialog.querySelector('[data-screen="area"] [data-back]');
          if (back) back.hidden = true;

          this.updateContinue();
          this.save();

          this.dialog.scrollTo({ top: 0, behavior: 'instant' });
          const heading = this.dialog.querySelector(`[data-screen="${screen}"] [data-heading]`);
          window.requestAnimationFrame(() => heading?.focus({ preventScroll: true }));
        }

        updateContinue() {
          const screen = this.state.screen;
          const button = this.querySelector('[data-continue]');
          const flow = this.flow();
          const last = flow[flow.indexOf(screen) + 1] === 'result';
          button.disabled = !this.canContinue(screen);
          this.querySelector('[data-continue-label]').textContent = last ? this.strings.seeRitual : this.strings.continue;
        }

        /* Composing the ritual ------------------------------------------------ */
        // Applies the rules in snippets/ritual-finder-rules: the smallest set
        // of products that covers every concern chosen (Essential), then at
        // most `max_complete` products that genuinely add to it (Complete the
        // ritual).
        recommend(area) {
          const rule = this.rules[area];
          const answers = rule.questions.flatMap((question) => this.values(question));
          const coverAnswers = rule.cover.flatMap((question) => this.values(question));
          const score = {};
          const reasons = {};

          answers.forEach((id, order) => {
            Object.entries(rule.weights[id] || {}).forEach(([handle, weight]) => {
              score[handle] = (score[handle] || 0) + weight;
              if (weight > 0) (reasons[handle] ||= []).push({ id, weight, order });
            });
          });

          const excluded = new Set(answers.flatMap((id) => rule.exclude[id] || []));
          const scoreOf = (handle) => score[handle] || 0;
          const weight = (handle, id) => (rule.weights[id] || {})[handle] || 0;
          const required = new Set(answers.flatMap((id) => rule.require[id] || []));
          const eligible = (handle) =>
            Boolean(this.template(handle)) && !excluded.has(handle) && (scoreOf(handle) > 0 || required.has(handle));
          // Compares [a, b, c] keys left to right; a tie keeps the product
          // found first, which is the earlier one in the ritual sequence.
          const better = (key, than) => {
            for (let index = 0; index < key.length; index += 1) {
              if (key[index] !== than[index]) return key[index] > than[index];
            }
            return false;
          };
          const bySequence = (a, b) => rule.sequence.indexOf(a) - rule.sequence.indexOf(b);

          // 1. Products an answer requires (the wash answer: Pure Wash).
          let essential = [];
          answers.forEach((id) =>
            (rule.require[id] || []).forEach((handle) => {
              if (eligible(handle) && !essential.includes(handle)) essential.push(handle);
            })
          );

          // 2. The smallest cover: repeatedly take the product that answers
          //    the most still-open concerns (weight 2+), then the strongest.
          const covered = new Set(coverAnswers.filter((id) => essential.some((handle) => weight(handle, id) >= 2)));
          for (;;) {
            const open = coverAnswers.filter((id) => !covered.has(id));
            if (!open.length) break;
            let pick = null;
            let pickKey = null;
            rule.sequence.forEach((handle) => {
              if (!eligible(handle) || essential.includes(handle)) return;
              const hits = open.filter((id) => weight(handle, id) >= 2);
              if (!hits.length) return;
              const key = [hits.length, hits.reduce((sum, id) => sum + weight(handle, id), 0), scoreOf(handle)];
              if (!pick || better(key, pickKey)) {
                pick = handle;
                pickKey = key;
              }
            });
            if (!pick) break;
            essential.push(pick);
            open.forEach((id) => {
              if (weight(pick, id) >= 2) covered.add(id);
            });
          }

          // 3. One of each rival pair; the other may return as a complement.
          rule.rivals.forEach(([first, second]) => {
            if (!essential.includes(first) || !essential.includes(second)) return;
            const loser = scoreOf(second) > scoreOf(first) ? first : second;
            essential = essential.filter((handle) => handle !== loser);
          });

          // 4. The cap: the product picked last drops first.
          let cap = rule.max_essential;
          answers.forEach((id) => {
            if (rule.cap_answers[id]) cap = Math.min(cap, rule.cap_answers[id]);
          });
          essential = essential.slice(0, cap);

          if (!essential.length) {
            const best = rule.sequence.filter(eligible).sort((a, b) => scoreOf(b) - scoreOf(a) || bySequence(a, b))[0];
            if (best) essential = [best];
          }

          // 5. Complete the ritual: only products that add something real,
          //    covering a concern left open or bringing a stronger weight
          //    (3 over 2) to one the essentials meet only as a secondary benefit.
          const relevant = answers.filter((id) => Object.values(rule.weights[id] || {}).some((value) => value >= 2));
          const chosen = [...essential];
          const complete = [];
          while (complete.length < (rule.max_complete ?? 1)) {
            let pick = null;
            let pickKey = null;
            rule.sequence.forEach((handle) => {
              if (!eligible(handle) || chosen.includes(handle)) return;
              const gain = relevant.reduce((sum, id) => {
                const value = weight(handle, id);
                if (value < 2) return sum;
                // Only real coverage (2+) counts as already having it.
                const have = Math.max(0, ...chosen.map((other) => weight(other, id)).filter((existing) => existing >= 2));
                return sum + Math.max(0, value - have);
              }, 0);
              if (gain <= 0) return;
              const key = [gain, scoreOf(handle)];
              if (!pick || better(key, pickKey)) {
                pick = handle;
                pickKey = key;
              }
            });
            if (!pick) break;
            complete.push(pick);
            chosen.push(pick);
          }

          essential.sort(bySequence);
          complete.sort(bySequence);
          const notes = [...new Set(answers.map((id) => rule.notes[id]).filter(Boolean))];

          return { area, answers, essential, complete, reasons, notes, signature: `${area}:${answers.join(',')}` };
        }

        compose({ track = true } = {}) {
          const area = this.area;
          if (!area) return;
          const recommendation = this.recommend(area);
          this.recommendation = recommendation;

          // New answers mean a new ritual: forget earlier removals.
          if (recommendation.signature !== this.state.signature) {
            this.state.signature = recommendation.signature;
            this.state.excluded = [];
            this.state.optionalIn = [];
          }

          const rule = this.rules[area];
          this.querySelector('[data-result-area]').textContent = this.strings.areas[area] || '';
          this.querySelector('[data-summary]').textContent = this.summary(recommendation);

          const essentialList = this.querySelector('[data-essential]');
          essentialList.replaceChildren(
            ...recommendation.essential.map((handle, index) => this.item(handle, rule, recommendation, index + 1))
          );

          const optionalGroup = this.querySelector('[data-optional-group]');
          const optionalList = this.querySelector('[data-optional-list]');
          optionalList.replaceChildren();
          optionalGroup.hidden = !recommendation.complete.length;
          optionalList.append(...recommendation.complete.map((handle) => this.item(handle, rule, recommendation, null)));

          const notes = this.querySelector('[data-notes]');
          notes.replaceChildren(
            ...recommendation.notes.map((key) => {
              const paragraph = document.createElement('p');
              paragraph.textContent = this.strings.notes[key] || '';
              return paragraph;
            })
          );

          this.querySelector('[data-status]').textContent = '';
          this.querySelector('[data-error]').textContent = '';
          this.setIndividual(false);
          this.updateTotal();

          if (track) {
            this.track('ritual_completed', {
              area,
              answers: recommendation.answers,
              essential: recommendation.essential,
              complete: recommendation.complete,
            });
          }
        }

        summary({ area, essential }) {
          const rule = this.rules[area];
          const concerns = this.values(rule.questions[0]);
          const terms = concerns.map((id) => this.strings.terms[area]?.[id]).filter(Boolean);
          const shown = terms.length > 3 ? [...terms.slice(0, 2), this.strings.more] : terms;
          const count = this.strings.counts[essential.length] || this.strings.counts[this.strings.counts.length - 1];
          let text = (this.strings.summary[area] || '').replace('[count]', count).replace('[list]', this.list.format(shown));

          if (area === 'skin') {
            const type = this.values('skin_type')[0];
            if (type && type !== 'not_sure') {
              text += ` ${this.strings.summary.skinType.replace('[type]', this.strings.skinTypes[type] || type)}`;
            }
          }
          return text;
        }

        template(handle) {
          return this.querySelector(`template[data-product-template="${handle}"]`);
        }

        item(handle, rule, recommendation, number) {
          const element = this.template(handle).content.firstElementChild.cloneNode(true);
          const optional = number === null;
          const purpose = this.strings.purpose[rule.purpose[handle]] || '';

          element.querySelector('[data-number]').textContent = optional ? '' : String(number).padStart(2, '0');
          element.querySelector('[data-purpose]').textContent = purpose;

          // Hair and skin name their two strongest reasons; Lumi Touch names
          // every concern chosen, since each one is why it is here.
          const phrases = (recommendation.reasons[handle] || [])
            .slice()
            .sort((a, b) => b.weight - a.weight || a.order - b.order)
            .map(({ id }) => this.strings.reasons[handle]?.[id])
            .filter(Boolean);
          const unique = [...new Set(phrases)];
          const limited = rule.sequence.length > 1 ? unique.slice(0, optional ? 1 : 2) : unique;
          if (limited.length) {
            const template = optional ? this.strings.optionalFor : this.strings.selectedFor;
            element.querySelector('[data-why]').textContent = template.replace('[list]', this.list.format(limited));
          }

          element.dataset.optional = optional ? 'true' : 'false';
          this.paint(element);
          return element;
        }

        /* Removing and adding back ------------------------------------------ */
        included(handle) {
          const element = this.dialog.querySelector(`.rfinder-item[data-item="${handle}"]`);
          if (!element || element.dataset.available !== 'true') return false;
          if (element.dataset.optional === 'true') return this.state.optionalIn.includes(handle);
          return !this.state.excluded.includes(handle);
        }

        paint(element) {
          const handle = element.dataset.item;
          const optional = element.dataset.optional === 'true';
          const available = element.dataset.available === 'true';
          const inRitual = available && (optional ? this.state.optionalIn.includes(handle) : !this.state.excluded.includes(handle));
          element.dataset.state = inRitual ? 'in' : 'out';

          const toggle = element.querySelector('[data-toggle]');
          const title = element.dataset.title;

          // An optional step reads "Add to ritual" or, once added, "Added ✓"
          // (the check is a quiet gold mark); its name says the same, e.g.
          // "Added to ritual: Root Elixir".
          if (optional) {
            toggle.removeAttribute('aria-pressed');
            toggle.querySelector('[data-label]').textContent = inRitual ? this.strings.added : this.strings.addToRitual;
            toggle.querySelector('[data-added-mark]').hidden = !inRitual;
            toggle.setAttribute('aria-label', `${inRitual ? this.strings.addedToRitual : this.strings.addToRitual}: ${title}`);
            return;
          }

          toggle.setAttribute('aria-pressed', String(!inRitual));
          const label = inRitual ? this.strings.remove : this.strings.addBack;
          toggle.querySelector('[data-label]').textContent = label;
          toggle.setAttribute('aria-label', `${label}: ${title}`);
        }

        toggle(element) {
          const handle = element.dataset.item;
          const optional = element.dataset.optional === 'true';
          const wasIn = this.included(handle);

          if (optional) {
            this.state.optionalIn = wasIn
              ? this.state.optionalIn.filter((item) => item !== handle)
              : [...this.state.optionalIn, handle];
          } else if (wasIn) {
            this.state.excluded = [...this.state.excluded, handle];
          } else {
            this.state.excluded = this.state.excluded.filter((item) => item !== handle);
          }

          if (wasIn) this.track('ritual_product_removed', { area: this.area, product: handle, optional });
          this.paint(element);
          this.updateTotal();
          this.save();
        }

        /* Total --------------------------------------------------------------- */
        currentItems() {
          return [...this.dialog.querySelectorAll('.rfinder-result .rfinder-item')].filter((element) =>
            this.included(element.dataset.item)
          );
        }

        // When the chosen products are exactly one of the ritual sets, the set
        // (a Shopify bundle) is used: same products, its ritual price.
        matchingSet(handles) {
          if (handles.length < 2) return null;
          const key = [...handles].sort().join(',');
          return (
            this.data.bundles.find(
              (bundle) => bundle.available && bundle.variant && [...bundle.components].sort().join(',') === key
            ) || null
          );
        }

        updateTotal() {
          const items = this.currentItems();
          const handles = items.map((element) => element.dataset.item);
          const regular = items.reduce((sum, element) => sum + Number(element.dataset.price || 0), 0);
          const set = this.matchingSet(handles);
          const total = set ? set.price : regular;
          this.set = set;

          const countText = (items.length === 1 ? this.strings.formulationsOne : this.strings.formulationsOther).replace(
            '[count]',
            items.length
          );
          this.querySelector('[data-count]').textContent = items.length ? countText : '';
          this.querySelector('[data-total]').textContent = items.length ? this.money(total) : '';
          this.querySelectorAll('[data-total-inline]').forEach((element) => (element.textContent = this.money(total)));

          const regularElement = this.querySelector('[data-regular]');
          const saving = this.querySelector('[data-saving]');
          const setNote = this.querySelector('[data-set-note]');
          const hasSaving = Boolean(set) && regular > total;
          regularElement.hidden = !hasSaving;
          saving.hidden = !hasSaving;
          setNote.hidden = !set;
          if (hasSaving) {
            this.querySelector('[data-regular-value]').textContent = this.money(regular);
            saving.textContent = this.strings.saving.replace('[amount]', this.money(regular - total));
          }
          if (set) setNote.textContent = this.strings.setMatch.replace('[title]', set.title);

          this.querySelector('[data-none-note]').hidden = items.length > 0;
          this.querySelectorAll('[data-add-ritual]').forEach((button) => {
            if (button.getAttribute('aria-busy') !== 'true') button.disabled = items.length === 0;
          });
        }

        money(cents) {
          const format = this.data.moneyFormat || '[amount]';
          const value = Number(cents) / 100;
          const build = (thousands, decimal) => {
            const [whole, fraction] = value.toFixed(2).split('.');
            const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
            // Whole amounts drop ".00", like money_without_trailing_zeros.
            return fraction === '00' ? grouped : `${grouped}${decimal}${fraction}`;
          };
          return format.replace(/\{\{\s*(\w+)\s*\}\}|\[amount\]/, (match, key) => {
            switch (key) {
              case 'amount_no_decimals':
                return build(',', '.').split('.')[0];
              case 'amount_with_comma_separator':
                return build('.', ',');
              case 'amount_no_decimals_with_comma_separator':
                return build('.', ',').split(',')[0];
              case 'amount_with_apostrophe_separator':
                return build("'", '.');
              default:
                return build(',', '.');
            }
          });
        }

        /* Clicks inside the finder ------------------------------------------- */
        onClick(event) {
          const target = event.target;

          if (target.closest('[data-close]')) {
            this.close();
            return;
          }
          if (target.closest('[data-back]')) {
            this.back();
            return;
          }
          if (target.closest('[data-restart]')) {
            this.restart();
            return;
          }

          const toggle = target.closest('[data-toggle]');
          if (toggle) {
            this.toggle(toggle.closest('.rfinder-item'));
            return;
          }

          const individual = target.closest('[data-individual-toggle]');
          if (individual) {
            this.setIndividual(!this.result.hasAttribute('data-individual'));
            return;
          }

          const addRitual = target.closest('[data-add-ritual]');
          if (addRitual) {
            this.addRitual(addRitual);
            return;
          }

          const addSingle = target.closest('[data-add-single]');
          if (addSingle) {
            this.addSingle(addSingle);
            return;
          }

          const link = target.closest('[data-product-link]');
          if (link) {
            const element = link.closest('.rfinder-item');
            const items = [...this.dialog.querySelectorAll('.rfinder-result .rfinder-item')];
            this.track('ritual_product_clicked', {
              area: this.area,
              product: element?.dataset.item,
              position: items.indexOf(element) + 1,
              optional: element?.dataset.optional === 'true',
            });
            return;
          }

          // A click on the backdrop area does nothing: the finder is the page.
        }

        setIndividual(on) {
          this.result.toggleAttribute('data-individual', on);
          const button = this.querySelector('[data-individual-toggle]');
          button.setAttribute('aria-pressed', String(on));
          button.querySelector('[data-label]').textContent = on ? this.strings.shopTogether : this.strings.shopIndividually;
        }

        restart() {
          this.form.reset();
          this.state = { screen: 'area', excluded: [], optionalIn: [], signature: '' };
          this.recommendation = null;
          try {
            window.sessionStorage.removeItem(STORAGE_KEY);
          } catch (error) {
            // Storage unavailable: nothing to clear.
          }
          this.show('area');
        }

        /* Adding to the bag -------------------------------------------------- */
        busy(button, text) {
          button.dataset.labelDefault = button.querySelector('[data-label]').textContent;
          button.setAttribute('aria-busy', 'true');
          button.disabled = true;
          button.querySelector('[data-label]').textContent = text;
        }

        release(button, text) {
          button.removeAttribute('aria-busy');
          button.disabled = false;
          const label = button.querySelector('[data-label]');
          if (label && button.dataset.labelDefault) label.textContent = text || button.dataset.labelDefault;
        }

        async addRitual(button) {
          if (button.getAttribute('aria-busy') === 'true') return;
          const items = this.currentItems();
          if (!items.length) return;
          const handles = items.map((element) => element.dataset.item);
          const set = this.matchingSet(handles);
          const lines = set
            ? [{ id: Number(set.variant), quantity: 1 }]
            : items.map((element) => ({ id: Number(element.dataset.variant), quantity: 1 }));
          const buttons = [...this.querySelectorAll('[data-add-ritual]')];

          buttons.forEach((element) => this.busy(element, this.strings.adding));
          const ok = await this.add(lines, this.strings.addedStatus);
          buttons.forEach((element) => this.release(element, ok ? this.strings.added : null));
          this.updateTotal();

          if (ok) {
            this.track('ritual_added_to_cart', {
              area: this.area,
              mode: 'ritual',
              products: handles,
              set: set ? set.key : null,
              total: set ? set.price : items.reduce((sum, element) => sum + Number(element.dataset.price || 0), 0),
            });
            window.setTimeout(() => {
              buttons.forEach((element) => {
                if (element.getAttribute('aria-busy') !== 'true') {
                  element.querySelector('[data-label]').textContent = element.dataset.labelDefault;
                }
              });
            }, 2400);
          }
        }

        async addSingle(button) {
          if (button.getAttribute('aria-busy') === 'true') return;
          const element = button.closest('.rfinder-item');
          if (!element || element.dataset.available !== 'true') return;

          this.busy(button, this.strings.adding);
          const ok = await this.add(
            [{ id: Number(element.dataset.variant), quantity: 1 }],
            this.strings.addedSingle.replace('[title]', element.dataset.title)
          );
          this.release(button, ok ? this.strings.added : null);

          if (ok) {
            this.track('ritual_added_to_cart', {
              area: this.area,
              mode: 'single',
              products: [element.dataset.item],
              set: null,
              total: Number(element.dataset.price || 0),
            });
            window.setTimeout(() => {
              if (button.getAttribute('aria-busy') !== 'true') {
                button.querySelector('[data-label]').textContent = button.dataset.labelDefault;
              }
            }, 2400);
          }
        }

        // One /cart/add.js request, so a ritual is added whole or not at all.
        async add(items, message) {
          const status = this.querySelector('[data-status]');
          const error = this.querySelector('[data-error]');
          status.textContent = '';
          error.textContent = '';

          try {
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items }),
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.description || data.message || this.strings.error);

            status.textContent = message;
            document.dispatchEvent(new CustomEvent('noralusin:cart-add', { detail: data }));
            await this.refreshHeaderCart();
            return true;
          } catch (caught) {
            error.textContent = caught.message || this.strings.error;
            return false;
          }
        }

        async refreshHeaderCart() {
          const current = document.querySelector('.site-header__cart');
          const wrapper = current && current.closest('.shopify-section');
          if (!wrapper) return;

          try {
            const sectionId = wrapper.id.replace(/^shopify-section-/, '');
            const response = await fetch(`${window.location.pathname}?section_id=${encodeURIComponent(sectionId)}`);
            if (!response.ok) return;
            const html = await response.text();
            const next = new DOMParser().parseFromString(html, 'text/html').querySelector('.site-header__cart');
            if (next) current.replaceWith(next);
          } catch (error) {
            // The count catches up on the next page load.
          }
        }

        /* Session memory ------------------------------------------------------ */
        save() {
          const answers = {};
          QUESTION_NAMES.forEach((name) => (answers[name] = this.values(name)));
          try {
            window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ answers, ...this.state }));
          } catch (error) {
            // Storage unavailable (private mode, blocked): answers last for this page only.
          }
        }

        restore() {
          let saved = null;
          try {
            saved = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null');
          } catch (error) {
            saved = null;
          }
          if (!saved || !saved.answers) return;

          Object.entries(saved.answers).forEach(([name, values]) => {
            if (!QUESTION_NAMES.includes(name) || !Array.isArray(values)) return;
            this.form.querySelectorAll(`[name="${name}"]`).forEach((input) => {
              input.checked = values.includes(input.value);
            });
          });
          this.state = {
            screen: typeof saved.screen === 'string' ? saved.screen : 'area',
            excluded: Array.isArray(saved.excluded) ? saved.excluded : [],
            optionalIn: Array.isArray(saved.optionalIn) ? saved.optionalIn : [],
            signature: typeof saved.signature === 'string' ? saved.signature : '',
          };
          if (!this.flow().includes(this.state.screen)) this.state.screen = 'area';
        }

        /* Analytics ----------------------------------------------------------- */
        // A DOM event for anything on the page, and Shopify's customer events
        // (Shopify.analytics.publish) for a custom pixel, when present.
        track(name, detail = {}) {
          document.dispatchEvent(new CustomEvent('noralusin:ritual-finder', { detail: { name, ...detail } }));
          try {
            window.Shopify?.analytics?.publish?.(name, detail);
          } catch (error) {
            // Analytics must never interrupt the finder.
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ritual-guide-script"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ritual-guide')) {
    customElements.define(
      'ritual-guide',
      class RitualGuide extends HTMLElement {
        connectedCallback() {
          this.status = this.querySelector('[data-status]');
          this.error = this.querySelector('[data-error]');
          this.viewBag = this.querySelector('[data-view-bag]');
          this.addEventListener('submit', (event) => {
            const form = event.target;
            const button = event.submitter;
            if (form.matches('[data-ritual-add]')) {
              event.preventDefault();
              const id = Number(form.querySelector('[name="id"]').value);
              this.add(form, [{ id, quantity: 1 }], button);
            } else if (form.matches('[data-ritual-complete]')) {
              event.preventDefault();
              const items = [...form.querySelectorAll('[data-item]')].map((input) => ({ id: Number(input.value), quantity: 1 }));
              if (items.length) this.add(form, items, button);
            }
          });

          // Coming back from checkout with the back button restores this page
          // from the cache, still showing "Processing": put the labels back.
          window.addEventListener('pageshow', (event) => {
            if (!event.persisted) return;
            this.querySelectorAll('button[aria-busy="true"]').forEach((button) => {
              button.removeAttribute('aria-busy');
              if (button.dataset.labelDefault) this.setLabel(button, button.dataset.labelDefault);
            });
          });
        }

        buttonsOf(form) {
          return [...form.elements].filter((element) => element.type === 'submit');
        }

        setLabel(button, text) {
          button.querySelector('[data-label]').textContent = text;
        }

        // Add to bag stays on the page; a Buy button (data-buy) goes to an
        // isolated checkout with the same items and never touches the bag.
        async add(form, items, submitter) {
          const buttons = this.buttonsOf(form);
          const button = submitter || buttons.find((element) => !element.hasAttribute('data-buy'));
          if (!button || button.disabled) return;
          if (buttons.some((element) => element.getAttribute('aria-busy') === 'true')) return;
          const checkout = button.hasAttribute('data-buy');
          const label = button.querySelector('[data-label]').textContent;
          button.dataset.labelDefault = label;

          this.status.textContent = '';
          this.error.textContent = '';
          this.viewBag.hidden = true;
          // Holds every action on this form while one is in progress, so nothing is added twice.
          buttons.forEach((element) => element.setAttribute('aria-busy', 'true'));
          this.setLabel(button, checkout ? this.dataset.labelProcessing : this.dataset.labelAdding);
          const release = () => buttons.forEach((element) => element !== button && element.removeAttribute('aria-busy'));

          try {
            if (checkout) {
              // A separate one-off cart with only these items, so the bag is left untouched.
              window.location.assign(await window.Noralusin.buyNowCheckout(items));
              return;
            }

            // One request for every item, so a ritual is added whole or not at all.
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items }),
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.description || data.message || this.dataset.statusError);

            release();
            button.removeAttribute('aria-busy');
            this.setLabel(button, this.dataset.labelAdded);
            this.status.textContent = button.dataset.statusAdded;
            this.viewBag.hidden = false;
            document.dispatchEvent(new CustomEvent('noralusin:cart-add', { detail: data }));
            await this.refreshHeaderCart();
            window.setTimeout(() => {
              if (button.getAttribute('aria-busy') !== 'true') this.setLabel(button, label);
            }, 2400);
          } catch (error) {
            release();
            button.removeAttribute('aria-busy');
            this.setLabel(button, label);
            this.error.textContent = error.message || this.dataset.statusError;
          }
        }

        async refreshHeaderCart() {
          const current = document.querySelector('.site-header__cart');
          const wrapper = current && current.closest('.shopify-section');
          if (!wrapper) return;

          try {
            const sectionId = wrapper.id.replace(/^shopify-section-/, '');
            const response = await fetch(`${window.location.pathname}?section_id=${encodeURIComponent(sectionId)}`);
            if (!response.ok) return;
            const html = await response.text();
            const next = new DOMParser().parseFromString(html, 'text/html').querySelector('.site-header__cart');
            if (next) current.replaceWith(next);
          } catch (error) {
            // The count catches up on the next page load.
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-overlay"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('predictive-search')) {
    class PredictiveSearch extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const { signal } = this.abort;

        this.dialog = this.closest('dialog');
        this.form = this.querySelector('form');
        this.input = this.querySelector('[data-search-input]');
        this.discover = this.querySelector('[data-search-discover]');
        this.results = this.querySelector('[data-search-results]');
        this.status = this.querySelector('[data-search-status]');
        this.minChars = Number(this.dataset.minChars) || 2;
        this.cache = new Map();
        this.fullCounts = new Map();
        this.options = [];
        this.activeIndex = -1;

        this.input.addEventListener(
          'input',
          () => {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.search(), 250);
          },
          { signal }
        );

        this.input.addEventListener('keydown', (event) => this.onKeydown(event), { signal });

        this.form.addEventListener('submit', (event) => this.onSubmit(event), { signal });

        this.addEventListener(
          'click',
          (event) => {
            const term = event.target.closest('[data-search-term]');
            if (term) {
              this.input.value = term.dataset.searchTerm;
              this.input.focus();
              this.search();
              return;
            }
            if (event.target.closest('[data-search-close]')) this.dialog.close();
          },
          { signal }
        );

        this.results.addEventListener(
          'pointermove',
          (event) => {
            const option = event.target.closest('[role="option"]');
            if (option && this.options.indexOf(option) !== this.activeIndex) this.setActive(-1);
          },
          { signal }
        );

        this.dialog.addEventListener(
          'click',
          (event) => {
            if (event.target === this.dialog) this.dialog.close();
          },
          { signal }
        );

        this.dialog.addEventListener('close', () => this.onClose(), { signal });

        document.addEventListener(
          'click',
          (event) => {
            const opener = event.target.closest('[data-search-open]');
            if (!opener || event.defaultPrevented) return;
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            this.open(opener);
          },
          { signal }
        );
      }

      disconnectedCallback() {
        this.abort.abort();
        this.request?.abort();
        clearTimeout(this.timer);
      }

      open(opener) {
        if (this.dialog.open) return;
        this.opener = opener;
        const header = document.querySelector('.site-header');
        const top = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
        this.dialog.style.setProperty('--search-overlay-top', `${top}px`);
        opener.setAttribute('aria-expanded', 'true');
        this.dialog.showModal();
        this.input.focus();
        if (this.input.value) this.input.select();
      }

      onClose() {
        clearTimeout(this.timer);
        this.request?.abort();
        this.classList.remove('is-loading');
        this.setActive(-1);
        document.querySelectorAll('[data-search-open][aria-expanded]').forEach((el) => el.setAttribute('aria-expanded', 'false'));

        let target = this.opener;
        if (!target || !target.isConnected || !target.checkVisibility?.()) {
          target = Array.from(document.querySelectorAll('[data-search-open]')).find((el) => el.checkVisibility?.());
        }
        target?.focus({ preventScroll: true });
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.dialog.close();
          return;
        }

        if (!this.options.length || this.results.hidden) return;

        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          const step = event.key === 'ArrowDown' ? 1 : -1;
          let next = this.activeIndex + step;
          if (next >= this.options.length) next = 0;
          if (next < -1) next = this.options.length - 1;
          this.setActive(next);
          return;
        }

        if (event.key === 'Enter' && this.activeIndex > -1) {
          event.preventDefault();
          const option = this.options[this.activeIndex];
          const link = option.matches('a') ? option : option.querySelector('a');
          link?.click();
        }
      }

      setActive(index) {
        this.options.forEach((option, i) => option.setAttribute('aria-selected', String(i === index)));
        this.activeIndex = index;
        const active = this.options[index];
        if (active) {
          this.input.setAttribute('aria-activedescendant', active.id);
          active.scrollIntoView({ block: 'nearest' });
        } else {
          this.input.removeAttribute('aria-activedescendant');
        }
      }

      showDiscover() {
        this.request?.abort();
        this.classList.remove('is-loading');
        this.results.hidden = true;
        this.results.replaceChildren();
        if (this.discover) this.discover.hidden = false;
        this.options = [];
        this.setActive(-1);
        this.input.setAttribute('aria-expanded', 'false');
        this.status.textContent = '';
      }

      async search() {
        clearTimeout(this.timer);
        const terms = this.input.value.trim();

        if (terms.length < this.minChars) {
          this.showDiscover();
          return 0;
        }

        const key = terms.toLowerCase();
        if (this.cache.has(key)) return this.render(terms, this.cache.get(key));

        this.request?.abort();
        this.request = new AbortController();
        this.classList.add('is-loading');

        const params = new URLSearchParams({
          q: this.dataset.exclude ? `${terms} ${this.dataset.exclude}` : terms,
          section_id: this.dataset.section,
          'resources[type]': 'product,collection,page,article',
          'resources[limit]': '6',
          'resources[limit_scope]': 'each',
          'resources[options][unavailable_products]': 'last',
          'resources[options][fields]': 'title,product_type,variants.title,vendor,body,tag',
        });

        try {
          const response = await fetch(`${this.dataset.url}?${params}`, { signal: this.request.signal });
          if (!response.ok) throw new Error(String(response.status));
          const html = await response.text();
          const markup = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-predictive-results]');
          if (!markup) throw new Error('empty');
          this.cache.set(key, markup.outerHTML);
          return this.render(terms, markup.outerHTML);
        } catch (error) {
          if (error.name !== 'AbortError') this.classList.remove('is-loading');
          return 0;
        }
      }

      /* The number of results the full search page returns for these terms,
         read by rendering this same section in the search page's context.
         Resolves to null when it can't be checked, which never blocks. */
      fullCount(terms) {
        const key = terms.toLowerCase();
        if (!this.fullCounts.has(key)) {
          const params = new URLSearchParams({ q: terms, type: 'product,article,page', section_id: this.dataset.section });
          const count = fetch(`${this.form.getAttribute('action')}?${params}`)
            .then((response) => (response.ok ? response.text() : null))
            .then((html) => {
              const el = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-full-search]');
              return el ? Number(el.dataset.count) : null;
            })
            .catch(() => null);
          this.fullCounts.set(key, count);
        }
        return this.fullCounts.get(key);
      }

      /* "View all results" appears only when the full search has results.
         When it has none, a hint takes its place and the link leaves the
         keyboard order. */
      async checkFullResults(terms) {
        const footer = this.results.querySelector('[data-search-footer]');
        if (!footer) return;
        const count = await this.fullCount(terms);
        if (this.input.value.trim() !== terms || !footer.isConnected) return;

        const hasResults = count !== 0;
        footer.dataset.state = hasResults ? 'ok' : 'none';
        const viewAll = footer.querySelector('[data-search-view-all]');
        if (hasResults) {
          if (viewAll && !this.options.includes(viewAll)) this.options.push(viewAll);
        } else {
          this.options = this.options.filter((option) => option !== viewAll);
          const hint = footer.querySelector('.predictive-results__hint');
          if (hint) this.status.textContent = `${this.status.textContent} ${hint.textContent}`;
        }
      }

      /* Enter goes to the full search page, unless the suggestions show
         results the full page would not: then it highlights the first
         suggestion instead of opening an empty page. */
      async onSubmit(event) {
        event.preventDefault();
        const terms = this.input.value.trim();
        if (!terms) return;

        const suggestions = await this.search();
        let count = null;
        if (suggestions > 0) {
          count = await Promise.race([this.fullCount(terms), new Promise((resolve) => setTimeout(resolve, 2500, null))]);
        }
        if (this.input.value.trim() !== terms || !this.dialog.open) return;

        if (count === 0 && this.options.length) {
          this.setActive(0);
        } else {
          this.form.submit();
        }
      }

      render(terms, markup) {
        if (this.input.value.trim() !== terms) return;
        this.classList.remove('is-loading');
        this.results.innerHTML = markup;
        this.results.hidden = false;
        if (this.discover) this.discover.hidden = true;

        this.options = Array.from(this.results.querySelectorAll('[role="option"]:not([data-search-view-all])'));
        this.setActive(-1);
        this.input.setAttribute('aria-expanded', String(this.options.length > 0));

        const summary = this.results.querySelector('[data-predictive-results]');
        this.status.textContent = summary?.dataset.status || '';

        const count = Number(summary?.dataset.count) || 0;
        if (count > 0) this.checkFullResults(terms);
        return count;
      }
    }

    customElements.define('predictive-search', PredictiveSearch);
  }
  } catch(e) { console.error(e); }
})();

})();
